module.exports = __webpack_public_path__ + "static/media/person-kevin-schoon.901ba9b4.png";